import i18n, { use } from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { resources } from "./i18n/resources";

use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources,
    detection: {
      // Review configuration for better detection
      // order: ["navigator"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
